import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropDownMenuModule } from '../drop-down-menu/drop-down-menu.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { FiltersBarComponent } from './filters-bar.component';

@NgModule({
    declarations: [
        FiltersBarComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DropDownMenuModule,
        SvgIconModule
    ],
    exports: [
        FiltersBarComponent
    ]
})
export class FiltersBarModule { }
